import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../app/RootReducer";
import {SpinnerOnTop} from "../../../components/SpinnerOnTop";
import {userResetPasswordRequest} from "../UsersSlice";
import t from "../../../components/I18N/TranslateHelpers";
import {renderEmailWithPattern} from "../../../components/Forms/FormsComponent";
const AskNewPasswordForm = () => {
  const dispatch = useDispatch();
  const isRequesting = useSelector((state: RootState) => state.userRdc.isRequestingNewPassword);
  const success = useSelector((state: RootState) => state.userRdc.isRequestingNewPasswordSuccess);
  const error = useSelector((state: RootState) => state.userRdc.error);

  const { register, handleSubmit, formState: { errors } } =  useForm();
  const [customerEmail, setCustomerEmail] = useState("");

  const onSubmit = (data:any) =>
  {
    // alert(JSON.stringify(data));
    setCustomerEmail(data.email)
    dispatch(userResetPasswordRequest(data.email));
  }

  return(
    isRequesting ?
      <div className="py-5">
        <SpinnerOnTop/>
      </div>
      :
      success ?
        <div className="alert alert-success" role="alert">
          {t('email_sent') + " " + customerEmail }
        </div>
        :
        error ?
          <div className="col-md-12 pt-3 text-white">{t('error')} {error.message}</div>
          :
          <form action="#" className="login-signup-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="mb-3">
                {
                  renderEmailWithPattern(t('email'),register,"email", true, errors.email, false, "")
                }
                {errors.email ? errors.email.type === 'pattern' ?
                    <span className="invalid-feedback">{t("invalid_address")}</span> :
                    <span className="invalid-feedback">{t("fields_required")}</span> : null}
              </div>
              <div className="col-md-12 align-items-center py-3">
                <button className="btn btn-primary width100" type="submit">
                  { t("ask_new_password")}
                </button>
              </div>
            </div>
          </form>
  )
}

export default AskNewPasswordForm;
